import * as React from "react";

import { CurrentUserContext } from "@v2/contexts/CurrentUserContext";

export default function useCurrentUser() {
  return React.useContext(CurrentUserContext);
}
